import React from "react";
import { motion } from "framer-motion";
import email from "../../../assets/images/email.gif";
import { ImMap } from "react-icons/im";
import { MdEmail } from "react-icons/md";
import { FaPhone } from "react-icons/fa";

const ContactMe = () => {
  return (
    <div className="container m-auto mt-36" id="contact">
      <h1
        className="text-5xl font-bold py-5 text-center"
        style={{ fontSize: "3rem" }}
      >
        CONTACT ME
      </h1>
      <div
        data-aos="fade-right"
        data-aos-duration="1500"
        id="contact"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, ease: "easeInOut" }}
        className="hero mb-32"
      >
        <div className="hero-content grid grid-cols-1 lg:grid-cols-5 p-0 ">
          <div className="text-center lg:text-left col-span-5 lg:col-span-2 pt-0 pl-4">
            <div className="mb-16 text-left">
              <h1 className="text-5xl font-semibold mb-5">Get in touch</h1>
              <p className="text-xl leading-relaxed">
                Send me an email if you think I can help you out with any of
                your web related projects.
              </p>
            </div>

            <div className="flex">
              <ImMap className="text-3xl text-pink-600"></ImMap>{" "}
              <div className="ml-4 font-bold text-left">
                <h1>Address:</h1>
                <h1 className="font-bold ">
                  Emil-Figge Str.44227, Dortmund, Germany.
                </h1>
              </div>
            </div>
            <div className="flex mt-5">
              <MdEmail className="text-3xl text-pink-600"></MdEmail>{" "}
              <div className="ml-4 font-bold text-left">
                <h1>Email:</h1>
                <h1 className="font-bold ">engr.shariful.cse@gmail.com</h1>
              </div>
            </div>
            <div className="flex mt-5 text-left">
              <FaPhone className="text-3xl text-pink-600"></FaPhone>{" "}
              <div className="ml-4 font-bold">
                <h1>Phone:</h1>
                <h1 className="font-bold ">+4915221472586</h1>
              </div>
            </div>
          </div>

          <div className="card w-full shadow-2xl bg-base-100 col-span-5 lg:col-span-3">
            <form
              action="https://formsubmit.co/engr.shariful.cse@gmail.com"
              method="POST"
              className="card-body "
            >
              <div className="form-control">
                <label className="label">
                  <span className="label-text">Your Name</span>
                </label>
                <input
                  type="text"
                  placeholder="Your Email"
                  name="name"
                  className="input input-bordered bg-white text-black rounded"
                />
              </div>
              <div className="form-control">
                <label className="label">
                  <span className="label-text">Email</span>
                </label>
                <input
                  type="email"
                  placeholder="Your Email"
                  name="email"
                  className="input input-bordered bg-white text-black rounded"
                />
              </div>
              <div className="form-control">
                <label className="label">
                  <span className="label-text">Body</span>
                </label>
                <textarea
                  type="text"
                  placeholder="Your message"
                  name="message"
                  className="input input-bordered h-40 bg-white text-black rounded"
                />
              </div>
              <div className="form-control mt-6">
                <button className="bg-green-600 p-2 text-2xl font-bold rounded">
                  Send Email
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactMe;
